import ClippingFeature from "../data/clipping_feature";
/**
 * @description: 设置裁剪区
 * @param {Object} geojsonObject(目前仅支持传入区或多区几何对象)
 * @return {*}
 */
function applyClippingFeature(data) {
    if (data) {
        let geometry = data
        // 验证输入的合法性
        if (data.type == "Feature" && data.geometry) {
            geometry = data.geometry
        }
        const geometryType = geometry.type
        if(geometryType!=="MultiPolygon" && geometryType!=="Polygon"){
            throw new Error("不支持传入区或多区之外的裁剪几何对象");
        }
        if (this._clippingFeature) {
            // 清空裁剪区缓存，销毁buffer
            this._clippingFeature.destroy();
        } 
        this._clippingFeature = new ClippingFeature({
            crs: this.crs,
        });
        // 几何转换为顶点
        if (geometry.type === "MultiPolygon") {
            geometry.coordinates.forEach((polygon) => {
                this._clippingFeature.addPolygonCoordinates(polygon);
            });
        } else {
            this._clippingFeature.addPolygonCoordinates(
                geometry.coordinates
            );
        }
    } else {
        // 如果输入为空，则卸载裁剪区
        if (this._clippingFeature) {
            this._clippingFeature.destroy();
        }
        this._clippingFeature = null;
    }
}

export { applyClippingFeature };
